import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { H3 } from "theme/components/atoms/Typography/Heading";
import Link from "theme/components/atoms/Typography/Link";

const messages = defineMessages({
  miniCartTitle: {
    id: "modules.Cart.MiniCart.MiniCartContent.title",
    defaultMessage: "My cart",
  },
  productsCount: {
    id: "modules.Cart.MiniCart.MiniCartContent.productsCount",
    defaultMessage: "({qty} {qty, plural, one {product} other {products}})",
  },
});

const MiniCartTitle = ({ cart }) => {
  const intl = useIntl();
  return (
    <div className="mini-cart-title">
      <H3 as="h2">
        <Link to="/cart">
          <span className="mini-cart-title__main">
            {intl.formatMessage(messages.miniCartTitle)}
          </span>
        </Link>
        {cart?.items_qty > 0 && (
          <>
            {" "}
            <span>
              {intl.formatMessage(messages.productsCount, {
                qty: cart.items_qty,
              })}
            </span>
          </>
        )}
      </H3>
    </div>
  );
};

export default MiniCartTitle;
